import { render, staticRenderFns } from "./tzDati.vue?vue&type=template&id=0b81fc5d&scoped=true&"
import script from "./tzDati.vue?vue&type=script&lang=js&"
export * from "./tzDati.vue?vue&type=script&lang=js&"
import style0 from "./tzDati.vue?vue&type=style&index=0&id=0b81fc5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b81fc5d",
  null
  
)

export default component.exports